export default __webpack_public_path__ + "static/media/opera.a7c57812.svg";